import { styled } from 'styled-components';

export const ScBonusShopBalanceSkeleton = styled.div`
  width: 169px;
  max-width: 100%;

  @container bonus-shop-heading (max-width: 355px) {
    width: 110px;
  }
`;
